// extracted by mini-css-extract-plugin
export default {"AdSlotMail__mail":"bgl_a bhl_wj bhl_a bhl_q bhl_k","AdSlotMail__mail--notLoaded":"bgl_b bhl_ey bhl_bj bhl_wy","show-ad-not-loaded":"bgl_c","AdSlotMail__cta":"bgl_e"};